import React, { useState } from "react";
import IoTModelViewerModal from "../../../ui/iot-model-viewer-modal/IoTModelViewerModal";
import { ReactComponent as InfoLetterIcon } from "../../../../assets/icons/info-letter-icon.svg";
import "./_help.scss";

const Help = () => {
  const [showHelp, setShowHelp] = useState(false);

  const handleHelpShow = (event: any) => {
    setShowHelp(true);
  };

  const handleHelpClose = (event: any) => {
    setShowHelp(false);
  };

  return (
    <>
      <button className="help__button" type="button" onClick={handleHelpShow}>
       <span className="visually-hidden">Help</span><InfoLetterIcon />
      </button>
      <IoTModelViewerModal isActive={showHelp} onClose={handleHelpClose}>
        <div className="help__modal-body">Modal Content</div>
      </IoTModelViewerModal>
    </>
  );
};

export default Help;
